function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
var Success = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(SvgIcon, _extends({
    "data-testid": "SuccessIcon"
  }, props, {
    ref: ref,
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10zm-11.694 4.568-.03-.029-.004.005-4.65-4.65a.985.985 0 0 1 1.392-1.393l3.287 3.287 5.904-5.905a.985.985 0 0 1 1.393 1.393l-7.292 7.292z",
      clipRule: "evenodd"
    })
  }));
});
Success.displayName = 'SuccessIcon';
export default Success;